import React, { useState } from 'react';

import { IconButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { Label } from '@eika/label';
import { LabelTypes } from '@eika/label/lib/types';
import { Modal } from '@eika/modal';

import { StringKeyValue } from '../../../actions/types';

export type TrafficLight = 'RED' | 'YELLOW' | 'GREEN';

interface Props {
    text: StringKeyValue;
    trafficLight: TrafficLight;
}

const TrafficLightComponent = ({ trafficLight, text }: Props): JSX.Element => {
    const [showTLModal, setShowTLModal] = useState(false);
    const trafficLightValues = {
        RED: {
            labelType: 'error' as LabelTypes,
            label: text.trafficLightRed,
            modalText: text.trafficLightModalP2Red,
        },
        YELLOW: {
            labelType: 'warning' as LabelTypes,
            label: text.trafficLightYellow,
            modalText: text.trafficLightModalP2Yellow,
        },
        GREEN: {
            labelType: 'success' as LabelTypes,
            label: text.trafficLightGreen,
            modalText: text.trafficLightModalP2Green,
        },
    };
    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                <Label
                    type={trafficLightValues[trafficLight].labelType}
                    text={`${text.trafficLightPre} ${trafficLightValues[trafficLight].label}`}
                />

                <IconButton
                    screenReaderText="Les mer om trafikklys"
                    icon={IconTypes.SPOERSMAALSTEGN_36}
                    onClick={() => setShowTLModal(true)}
                />
            </div>
            <Modal
                id="modal_trafficlight"
                onClose={() => setShowTLModal(false)}
                title={text.trafficLightModalTitle}
                open={showTLModal}
                setOpen={() => {}}
                appNamespace="no-eika-kredittbank"
            >
                {text.trafficLightModalP1 && <p>{text.trafficLightModalP1}</p>}
                {trafficLight && <p>{trafficLightValues[trafficLight].modalText}</p>}

                <div className="consent-item__close-modal">
                    <StandardButton onClick={() => setShowTLModal(false)}>{text.trafficLightModalClose}</StandardButton>
                </div>
            </Modal>
        </>
    );
};

export default TrafficLightComponent;
